import React from 'react';

import { Box, SimpleGrid } from '@chakra-ui/react';

import { IBlogItem } from '../../models/blog-item';
import { BlogItem } from '../blog-item/blog-item';

export interface IBlogProps {
  items: IBlogItem[];
}

export function Blog({ items }: IBlogProps) {
  return (
    <SimpleGrid minChildWidth="370px" spacing={12}>
      {items.map((item) => (
        <Box key={item.guid}>
          <BlogItem {...item} />
        </Box>
      ))}
    </SimpleGrid>
  );
}
